import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Heading } from '@superops/ui-design-system';
import { injectIntl, FormattedMessage } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';
import { SkeletonLoading, withErrorBoundary, Loader } from '@nile/components';
import QuoteDetailsPDF from '@nile/components/src/Pages/QuoteDetailsPdf';

const Header = styled.div`
  .Superops-Heading {
    filter: invert(1);
  }
`;

const VersionNumber = styled.div`
  padding: 10px;
  background: ${(props) => (props.selected ? '#222728' : 'transparent')};
  color: #fff;
  border-radius: 5px;
  &:hover {
    background: #222728;
  }
`;

let timer = null;

function VersionContainer(props) {
  const { versions, closeVersionModal } = props;
  const [selectedItem, setSelectedItem] = useState(0);
  const [loading, setLoading] = useState(false);
  // useEffect(() => {
  //   setLoading(true);
  //   if (timer) clearTimeout(timer);
  //   timer = setTimeout(() => {
  //     setLoading(false);
  //   }, 200);
  // }, [selectedItem]);
  return (
    <div className="full-height">
      <Header className="flex center">
        <Heading>
          <FormattedMessage id="quote.details.versions.title" />
        </Heading>
        <div className="mlauto pointer" onClick={closeVersionModal}>
          <SVGIcon name="Close" color="#ffffff" />
        </div>
      </Header>
      <div className="flex center g20 mt20 g50 ch-30">
        <div className="fg1 mw-300 self-start">
          {versions.map((el, idx) => {
            return (
              <VersionNumber
                selected={idx === selectedItem}
                onClick={() => {
                  setSelectedItem(idx);
                }}
              >
                {`Version - ${versions.length - idx}`}
              </VersionNumber>
            );
          })}
        </div>
        <div className="fg1 bg-white wm-950 w950 scroll br-5">
          {loading ? (
            <Loader />
          ) : (
            <QuoteDetailsPDF
              key={selectedItem}
              data={versions[selectedItem]}
              dataAvailable
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default injectIntl(withErrorBoundary(VersionContainer));
